import styled, { css } from 'styled-components';
import { getTextType, getSpace } from '../../../stylesheets/tools';

const StyledCopy = styled.p`
  ${getTextType('copy', 'international')}
  margin: ${getSpace('xs')} 0;
  padding: 0;

  ${props =>
    props.as === 'span' &&
    css`
      margin: 0;
    `};

  ${props =>
    props.noMargin &&
    css`
      margin: 0;
    `}

  ${props =>
    props.focused &&
    css`
      ${getTextType('copyFocused', 'international')};
    `}

  ${props =>
    props.thick &&
    css`
      ${getTextType('copyThick', 'international')};
    `}

  ${props =>
    props.small &&
    css`
      ${getTextType('copySmall', 'international')};
    `}

  ${props =>
    props.smallThick &&
    css`
      ${getTextType('copySmallThick', 'international')};
    `}

  ${props =>
    props.extraSmall &&
    css`
      ${getTextType('copyExtraSmall', 'international')};
    `}

   ${props =>
     props.uppercase &&
     css`
       text-transform: uppercase;
     `}
`;

export default StyledCopy;
